module.exports = __webpack_public_path__ + "img/2010 winteressen 015.d98cb608.jpg";